import React, { Component } from "react";
import { Table } from 'react-bootstrap';
import { withRouter} from 'react-router-dom';
import mixin from "../../../utils/mixin";

import './Log.scss';

import { getLogByLot } from '../../../api/Api.js';

const { methods } = mixin;

class Log extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      message: null,
      loading: false,
      lot: null,
      prev_lot_id: null,
      items: [],
    };
  }

  renderTitle(){
    if(this.props.lot){
      return `Bitácora: ${this.props.lot.name}`;
    }
    return 'Bitácora';
  }

  static getDerivedStateFromProps = (props, state) => {
    let l = null;
    
    if(props.lot_id !== state.prev_lot_id){
      
      if(props.lot){
        l = {...props.lot}
      }
      
      return{
        prev_lot_id: props.lot_id,
        lot: l,
      }
    }
    return null;
  }

  renderUserName = (user) => {
    if(user) {
      let name = '';
      name += user.first_name ? user.first_name : '';
      name += user.last_name ? ' ' + user.last_name : '';
      return name;
    }
    return '';
  }

  renderActionLabel = (type) => {
    switch(type){
      case 'CREATE': return 'Creación';
      case 'UPDATE': return 'Edición';
      case 'USER_RESERVATION': return 'Reservación Manual';
      case 'RESERVATION': return 'Reservación';
      case 'RESERVATION_FAILED': return 'Reservación Fallida';
      case 'RESERVATION_DECLINED': return 'Reservación con Pago Declinado';
      case 'CANCEL_RESERVATION': return 'Cancelación de Reservación';
      case 'UPDATE_RESERVATION': return 'Edición de Reservación';
      case 'CONFIRM_RESERVATION': return 'Confirmación de Reservación';
      default: return '';
    }
  }

  renderActionDescription = (type) => {
    switch(type){
      case 'CREATE': return 'creó el lote.';
      case 'UPDATE': return 'realizó modificaciones al lote.';
      case 'USER_RESERVATION': return 'realizó una reservación manual del lote para el cliente';
      case 'RESERVATION': return 'reservó el lote para el cliente';
      case 'RESERVATION_FAILED': return 'intentó reservar el lote. El pago no pudo ser completado, ningún cargo fue aplicado.';
      case 'RESERVATION_DECLINED': return 'intentó reservar el lote. El pago fue declinado.';
      case 'CANCEL_RESERVATION': return 'canceló la reservación del lote.';
      case 'UPDATE_RESERVATION': return 'realizó modificaciones a la reservación del lote.';
      case 'CONFIRM_RESERVATION': return 'aprobó la reservación manual del lote.';
      default: return '';
    }
  }

  renderLogTable = () => {

    if(this.state.loading){
      return (
        <span>Cargando...</span>
      );
    }

    let items = (this.state.items && this.state.items.length > 0) ? [...this.state.items] : [];

    const listLog = items ? items.map((i) => {
      return( 
        <tr key={i._id}>
          <td>{methods.G_simpleFormatDate({ date: i.time_created + 'Z' })}</td>
          <td>{this.renderActionLabel(i.type)}</td>
          <td>{this.renderUserName(i.user)}</td>
          <td>{this.renderUserName(i.customer)}</td>
          <td></td>
        </tr>
      )
    }) : [];

    if(listLog.length > 0){
      return (
        <Table responsive striped bordered hover size="sm">
          <thead>
            <tr>
              <th>Fecha</th>
              <th>Acción</th>
              <th>Usuario</th>
              <th>Cliente</th>
              <th>Detalles</th>
            </tr>
          </thead>
          <tbody>
            {listLog}
          </tbody>
        </Table>
      );
    }else{
      return (
        <span>No hay movimientos registrados.</span>
      );
    }
  }

  renderLog = () => {

    if(this.state.loading){
      return (
        <span>Cargando...</span>
      );
    }

    let items = (this.state.items && this.state.items.length > 0) ? [...this.state.items] : [];

    const listLog = items ? items.map((i) => {
      let client = '';
      if(i.type == 'USER_RESERVATION' || i.type == 'RESERVATION'){
        client = <span className="bold">{this.renderUserName(i.customer)}.</span>
      }
      return(
        <div key={i._id} className="log-item">
          <span className="bold">{this.renderUserName(i.user)}</span> {this.renderActionDescription(i.type)} {client}
          <div className="date">{methods.G_simpleFormatDate({ date: i.time_created + 'Z' })}</div>
        </div> 
      )
    }) : [];

    if(listLog.length > 0){
      return (
        <div className="log-container">
          {listLog}
        </div>
      );
    }else{
      return (
        <span>No hay movimientos registrados.</span>
      );
    }
  }

  dispatchLog = (lot_id) => {
    getLogByLot(lot_id).then((res) => {
      let items = [];
      if (res) {
          items = res;
      }
      this.setState({
        items: items ,
        loading: false,
      });
    });
  };

  componentDidMount() {
    
    this.setState({
      loading: true
    });

    if (this.props.action == 'log') {
      this.dispatchLog(this.props.lot_id);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.lot_id !== prevProps.lot_id && this.props.action == 'log') {
      this.dispatchLog(this.props.lot_id);
    }
  }

  render() {
    return (
      <div className="containter">
        {this.renderLog()}

        <div className="form-group text-right">
          <button className="btn btn-cust-red" onClick={this.props.close}>Volver</button>
        </div>

      </div>
    );
  }

}

export default withRouter(Log);